import { UseCaseRecursoAsync } from "src/views/core/types/UseCaseRecursoAsync";
import { DataLlave, EstadisticasLlave, EstadoLlaveAnual, ResumenByClienteProductoUsuario } from "../entities/EstadisticasLlave.entity";
import { EstadisticasDsKeyRepository } from "../repositories/EstadisticasDsKeyRepository";
import { Recurso } from 'lib.common/dist/CleanArch';
import { ErrDevGenerico } from 'lib.common/dist/errorHandler';
import { GetEstadoLlavesAnualParams } from "../../utils/params/EstadisticasDsKey.params";

export class GetEstadoLlavesAnualUseCase<
    T_OUT extends EstadisticasLlave,
    T_OUT2 extends DataLlave,
    T_OUT3 extends EstadoLlaveAnual,
    T_OUT4 extends ResumenByClienteProductoUsuario
> extends UseCaseRecursoAsync<
    GetEstadoLlavesAnualParams,
    T_OUT3[]
> {
    private repository: EstadisticasDsKeyRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>;
    constructor(repository: EstadisticasDsKeyRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>) {
        super();
        this.repository = repository;
    }

    async call(input: GetEstadoLlavesAnualParams): Promise<Recurso<T_OUT3[]>> {
        try {
            return this.repository.getEstadoLlavesAnual(input);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT3[]>(errorCapa);
        }
    }
}